import { render, staticRenderFns } from "./ImportsPage.vue?vue&type=template&id=7c8a7f7d&"
import script from "./ImportsPage.vue?vue&type=script&lang=js&"
export * from "./ImportsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports